import type { ComponentType, SVGProps } from 'react';
import { CloseIcon } from './icons/CloseIcon';
import { EditIcon } from './icons/EditIcon';
import { ErrorIcon } from './icons/ErrorIcon';
import { EyeOnIcon } from './icons/EyeOnIcon';
import { EyeOffIcon } from './icons/EyeOffIcon';
import { EyeClosedIcon } from './icons/EyeClosedIcon';
import { HelpIcon } from './icons/HelpIcon';
import { InformationIcon } from './icons/InformationIcon';
import { LocationIcon } from './icons/LocationIcon';
import { SuccessIcon } from './icons/SuccessIcon';
import { WarningIcon } from './icons/WarningIcon';
import { CreditCardIcon } from './icons/CreditCardIcon';
import { SupportIcon } from './icons/SupportIcon';
import { ShieldIcon } from './icons/ShieldIcon';
import { CurrencyIcon } from './icons/CurrencyIcon';
import { UsersIcon } from './icons/UsersIcon';
import { BankIcon } from './icons/BankIcon';
import { MenuIcon } from './icons/MenuIcon';
import { TransactionOutIcon } from './icons/TransactionOutIcon';
import { TransactionInIcon } from './icons/TransactionInIcon';
import { TransactionRejectedIcon } from './icons/TransactionRejectedIcon';
import { ChevronDownIcon } from './icons/ChevronDownIcon';
import { ChevronUpIcon } from './icons/ChevronUpIcon';
import { ChevronLeftIcon } from './icons/ChevronLeftIcon';
import { ChevronRightIcon } from './icons/ChevronRightIcon';
import { CheckIcon } from './icons/CheckIcon';
import { SearchIcon } from './icons/SearchIcon';
import { DownloadIcon } from './icons/DownloadIcon';
import { CalendarIcon } from './icons/CalendarIcon';

export type IconName =
  | 'close'
  | 'edit'
  | 'error'
  | 'eye-on'
  | 'eye-off'
  | 'eye-closed'
  | 'help'
  | 'information'
  | 'location'
  | 'success'
  | 'warning'
  | 'credit-card'
  | 'support'
  | 'shield'
  | 'currency'
  | 'users'
  | 'bank'
  | 'menu'
  | 'transaction-out'
  | 'transaction-in'
  | 'transaction-rejected'
  | 'chevron-down'
  | 'chevron-up'
  | 'chevron-left'
  | 'chevron-right'
  | 'check'
  | 'search'
  | 'download'
  | 'calendar';

export const icons: Record<IconName, ComponentType<SVGProps<SVGSVGElement>>> = {
  close: CloseIcon,
  edit: EditIcon,
  error: ErrorIcon,
  'eye-on': EyeOnIcon,
  'eye-off': EyeOffIcon,
  'eye-closed': EyeClosedIcon,
  help: HelpIcon,
  information: InformationIcon,
  location: LocationIcon,
  success: SuccessIcon,
  warning: WarningIcon,
  'credit-card': CreditCardIcon,
  support: SupportIcon,
  shield: ShieldIcon,
  currency: CurrencyIcon,
  users: UsersIcon,
  bank: BankIcon,
  menu: MenuIcon,
  'transaction-out': TransactionOutIcon,
  'transaction-in': TransactionInIcon,
  'transaction-rejected': TransactionRejectedIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-up': ChevronUpIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  check: CheckIcon,
  search: SearchIcon,
  download: DownloadIcon,
  calendar: CalendarIcon,
};
